import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { AuthGuard } from '../app/service/guards/auth.guard';
import { PermissionGuard } from '../app/service/guards/permission.guard';

const routes: Routes = [
  { path: '', redirectTo: '/auth', pathMatch: 'full' },
  {
    path: 'auth', component: LoginComponent,
    canLoad: [AuthGuard]
  },
  {
    path: 'template-generate', component: MainComponent,
    canActivate:[PermissionGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
